export default __webpack_public_path__ + "static/media/blindside.b636f103.png";